import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountLocationsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  accountLocationsFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.AccountLocationsFiltersInput>;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  order?: GraphQLTypes.InputMaybe<GraphQLTypes.SortInput>;
}>;

export type GetAccountLocationsQueryResult = { __typename?: 'Query' } & {
  accountLocations?: GraphQLTypes.Maybe<
    { __typename?: 'AccountLocationConnection' } & Pick<GraphQLTypes.AccountLocationConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'AccountLocation' } & Pick<
              GraphQLTypes.AccountLocation,
              'addressLabel' | 'id' | 'isArchived' | 'isRegisteredLegalAddress' | 'name'
            > & {
                account: { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>;
                label?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>>;
                permissions?: GraphQLTypes.Maybe<
                  { __typename?: 'LocationPermissions' } & {
                    canArchive?: GraphQLTypes.Maybe<
                      { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                    >;
                    canEditDetails?: GraphQLTypes.Maybe<
                      { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                    >;
                    canUnarchive?: GraphQLTypes.Maybe<
                      { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                    >;
                  }
                >;
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetAccountLocationsDocument = gql`
  query getAccountLocations(
    $accountId: String!
    $accountLocationsFiltersInput: AccountLocationsFiltersInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: SortInput
  ) {
    accountLocations(
      accountId: $accountId
      accountLocationsFiltersInput: $accountLocationsFiltersInput
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
    ) {
      nodes {
        account {
          id
          tradingName
        }
        addressLabel
        id
        isArchived
        isRegisteredLegalAddress
        label {
          long
        }
        name
        permissions {
          canArchive {
            value
          }
          canEditDetails {
            value
          }
          canUnarchive {
            value
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
